import { CiudadanoRoutingModule } from './ciudadano-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccesoCiudadanoComponent } from './pages/acceso-ciudadano/acceso-ciudadano.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { HomeCiudadanoComponent } from './pages/home-ciudadano/home-ciudadano.component';
import { CiudadanoComponent } from './ciudadano.component';

@NgModule({
  declarations: [AccesoCiudadanoComponent, HomeCiudadanoComponent, CiudadanoComponent],
  imports: [
    CommonModule,
    SharedModule,
    CiudadanoRoutingModule
  ]
})
export class CiudadanoModule { }
